import get from "lodash/get";
import { ILandingPageWidget } from "shared/components/AdPlatformWidgets/types";

export const generateInFocusParams = (widget: ILandingPageWidget) => {
    const inFocusData = { ...widget };
    const inFocusBanner = inFocusData.widget_data.children[0];
    const widgetData = {
        ...inFocusData.widget_data,
        children: inFocusData.widget_data.children.slice().filter(_ => {
            return _.wid !== inFocusBanner.wid;
        }),
    };
    return {
        title: get(widget, "widget_data.parameters.title", ""),
        titleAligment: get(widget, "widget_data.parameters.title_align_desktop", ""),
        inFocusBanner,
        inFocusData: widgetData,
    };
};
